module.exports = __webpack_public_path__ + "img/sky.6a83f5e.png";